module.exports = __webpack_public_path__ + "color.c7a33805ffda0d32bd2a";


//////////////////
// WEBPACK FOOTER
// /Volumes/Extension/工作项目/产品/SmartMapX平台/行业应用/app_gasStation/node_modules/primeng/resources/images/color.png
// module id = ../../../../primeng/resources/images/color.png
// module chunks = styles